import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariables } from 'global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public organization_list(): Observable<any> {
    return this._httpClient.get(this.url + 'users/getorganisationlist');
  }
  
  public getCurrenctDetail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'currency/' + id);
  }

  public total_campaign_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/total_campaign_count', data);
  }

  public active_campaign_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/active_campaign_count', data);
  }

  public update(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/update', data);
  }

  public issued_coupon_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/issued_coupon_count', data);
  }

  public total_claimed_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/total_claimed_count', data);
  }

  public total_redeemed_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/total_redeemed_count', data);
  }

  public total_sales_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/total_sales_count', data);
  }

  public today_claimed_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/today_claimed_count', data);
  }

  public today_redeemed_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/today_redeemed_count', data);
  }

  public today_sales_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/today_sales_count', data);
  }

  public monthly_report(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/monthly_report', data);
  }

  public chart_monthly_issued_coupon_count(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/chart_monthly_issued_coupon_count', data);
  }

  public summary(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'dashboard/admin/summary', data);
  }
}
